import { SearchIcon } from 'lucide-react';
import FigmaSearchIcon from '@/shared/assets/header/search.svg?react';
import { Input } from './ui/input';
import { cn } from '../utils/styling';
import React from 'react';

type Props = {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  size?: 'default' | 'sm';
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onPointerDown?: (e: React.PointerEvent<HTMLInputElement>) => void;
  onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onTouchStart?: (e: React.TouchEvent<HTMLInputElement>) => void;
};

const Search = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      label,
      placeholder,
      value,
      onChange,
      size = 'default',
      className,
      onKeyDown,
      onPointerDown,
      onBlur,
      onFocus,
      onClick,
      onTouchStart,
    },
    ref
  ) => {
    const isSmall = size === 'sm';

    return (
      <Input
        ref={ref}
        label={label}
        placeholder={placeholder}
        showLabel={false}
        value={value}
        icon={
          isSmall ? (
            <FigmaSearchIcon className="size-[2rem] text-secondary dark:text-secondary-foreground" />
          ) : (
            <SearchIcon className="size-7 ml-2 text-secondary dark:text-secondary-foreground" />
          )
        }
        onChange={onChange}
        onKeyDown={onKeyDown}
        onPointerDown={onPointerDown}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
        onTouchStart={onTouchStart}
        className={cn(
          isSmall
            ? 'rounded-[1rem] h-[3.2rem] py-[0.6rem] pl-[3.8rem] pr-[1.6rem] p4 bg-secondary-bg'
            : 'rounded-full h-[4.2rem] p3 bg-[#e8e8e8]',
          'dark:bg-secondary placeholder:text-secondary dark:placeholder:text-secondary-foreground',
          className
        )}
      />
    );
  }
);

Search.displayName = 'Search';

export { Search };
